import { pageRoute } from "../routeFactory";

const ccaapForeword = () => import("@/views/ccaap/ccaap-foreword.vue");
const ccaapPriorities = () => import("@/views/ccaap/ccaap-priorities.vue");
const ccaapAchievements = () => import("@/views/ccaap/ccaap-achievements.vue");
const climateIntelligence = () =>
  import("@/views/ccaap/climate-intelligence.vue");
const aResilientFuture = () =>
  import("@/views/ccaap/ccaap-resilient-future.vue");
const ccaapMaintainingInfrastructure = () =>
  import("@/views/ccaap/ccaap-maintaining-infrastructure.vue");
const ccaapSkillsAndCapabilities = () =>
  import("@/views/ccaap/ccaap-skills-and-capability.vue");
const ccaapStrengthenPartnerships = () =>
  import("@/views/ccaap/ccaap-strengthen-partnerships.vue");
const ccaapSucceedingPage = () => import("@/views/ccaap/ccaap-succeeding.vue");

const section = "ccaap";

export const ccaapChildren = [
  pageRoute({
    path: "ccaap-foreword",
    name: "ccaapForeword",
    component: ccaapForeword,
    section,
    bodyClass: "ccaap-foreword",
    titleKey: "nav.ccaap-foreword",
  }),
  pageRoute({
    path: "ccaap-priorities",
    name: "ccaapPriorities",
    component: ccaapPriorities,
    section,
    bodyClass: "ccaap-priorities",
    titleKey: "nav.ccaap-priorities",
  }),
  pageRoute({
    path: "ccaap-maintaining-infrastructure",
    name: "ccaapMaintainingInfrastructure",
    component: ccaapMaintainingInfrastructure,
    section,
    bodyClass: "ccaap-maintaining-infrastructure",
    titleKey: "nav.ccaap-maintaining-infrastructure",
  }),
  pageRoute({
    path: "ccaap-achievements",
    name: "ccaapAchievements",
    component: ccaapAchievements,
    section,
    bodyClass: "ccaap-achievements",
    titleKey: "nav.ccaap-achievements",
  }),
  pageRoute({
    path: "climate-intelligence",
    name: "climateIntelligence",
    component: climateIntelligence,
    section,
    bodyClass: "climate-intelligence",
    titleKey: "nav.climate-intelligence",
  }),
  pageRoute({
    path: "ccaap-resilient-future",
    name: "aResilientFuture",
    component: aResilientFuture,
    section,
    bodyClass: "ccaap-resilient-future",
    titleKey: "nav.resilient-future",
  }),
  pageRoute({
    path: "ccaap-strengthen-partnerships",
    name: "ccaapStrengthenPartnerships",
    component: ccaapStrengthenPartnerships,
    section,
    bodyClass: "ccaap-strengthen-partnerships",
    titleKey: "nav.strengthen-partnerships",
  }),
  pageRoute({
    path: "ccaap-skills-and-capabilities",
    name: "ccaapSkillsAndCapabilities",
    component: ccaapSkillsAndCapabilities,
    section,
    bodyClass: "ccaap-skills-and-capabilities",
    titleKey: "nav.skills-and-capabilities",
  }),
  pageRoute({
    path: "ccaap-succeeding",
    name: "ccaapSucceedingPage",
    component: ccaapSucceedingPage,
    section,
    bodyClass: "ccaap-succeeding",
    titleKey: "nav.succeeding",
  }),
];
